(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let dispose = [];
  function setup() {
    dispose.forEach(fn => fn()); dispose=[];
    if(preference.matches) return;
    const reveal = new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){e.target.classList.add('mw-reveal');reveal.unobserve(e.target);}
    }),{threshold:.12});
    document.querySelectorAll('.mw-section-heading,.mw-family-grid article,.mw-game-card,.mw-help-card').forEach(el=>reveal.observe(el));
    dispose.push(()=>reveal.disconnect());
    const stage=document.querySelector('[data-mw-hero-stage]'), hero=stage?.closest('.mw-hero'), story=document.querySelector('[data-mw-story]'), ticker=document.querySelector('[data-mw-ticker]');
    const finePointer=matchMedia('(hover:hover) and (pointer:fine)').matches;
    let frame=0;
    const update=()=>{
      frame=0;if(document.hidden)return;
      if(stage&&hero){const r=hero.getBoundingClientRect();const p=Math.max(0,Math.min(1,-r.top/Math.max(r.height,1)));stage.style.setProperty('--scroll-shift',`${-p*(finePointer?110:35)}px`);stage.style.setProperty('--scroll-turn',`${p*12}deg`);stage.style.setProperty('--scroll-scale',`${1+p*.1}`);stage.classList.toggle('is-inactive',r.bottom<0||r.top>innerHeight);}
      if(story){const r=story.getBoundingClientRect();const p=Math.max(0,Math.min(1,(innerHeight*.25-r.top)/Math.max(1,r.height-innerHeight*.5)));story.style.setProperty('--progress',p.toFixed(3));}
      if(ticker&&finePointer){const r=ticker.getBoundingClientRect();ticker.style.setProperty('--ticker-shift',`${Math.max(-90,Math.min(90,(innerHeight*.6-r.top)*.12))}px`);}
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);document.addEventListener('visibilitychange',schedule);update();
    dispose.push(()=>{removeEventListener('scroll',schedule);removeEventListener('resize',schedule);document.removeEventListener('visibilitychange',schedule);cancelAnimationFrame(frame);stage?.style.removeProperty('--scroll-shift');stage?.style.removeProperty('--scroll-turn');stage?.style.removeProperty('--scroll-scale');story?.style.removeProperty('--progress');ticker?.style.removeProperty('--ticker-shift');});
    if(finePointer)document.querySelectorAll('[data-mw-tilt]').forEach(el=>{
      const move=e=>{const r=el.getBoundingClientRect();el.style.setProperty('--tx',`${((e.clientX-r.left)/r.width-.5)*7}deg`);el.style.setProperty('--ty',`${-((e.clientY-r.top)/r.height-.5)*7}deg`);};
      const reset=()=>{el.style.removeProperty('--tx');el.style.removeProperty('--ty');};el.addEventListener('pointermove',move);el.addEventListener('pointerleave',reset);dispose.push(()=>{el.removeEventListener('pointermove',move);el.removeEventListener('pointerleave',reset);reset();});
    });
  }
  setup();preference.addEventListener('change',setup);document.addEventListener('shopify:section:load',setup);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mw-nav-toggle[open]').forEach(el=>{el.open=false;el.querySelector('summary')?.focus();});});
  document.addEventListener('click',e=>{document.querySelectorAll('.mw-nav-toggle[open]').forEach(el=>{if(!el.contains(e.target)||e.target.closest('a'))el.open=false;});});
})();


/* v3 floating navigation */
(() => {
  let cleanUp = () => {};
  const init = () => {
    cleanUp();
    const header = document.querySelector('[data-mw-floating-nav]');
    if (!header) return;
    const content = header.querySelector('[data-mw-nav-content]');
    const reopen = header.querySelector('.mw-nav-reopen');
    const menu = header.querySelector('.mw-nav-toggle');
    const controller = new AbortController(), signal = controller.signal;
    let lastY = Math.max(0, scrollY), travelled = 0, direction = 0;
    let compact = lastY > 130, pinned = false, hovered = false, frame = 0;
    const render = () => {
      const focused = content.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      const closed = compact && !pinned && !hovered && !focused && !menu?.open;
      header.classList.toggle('is-compact', closed);
      content.inert = closed;
      content.setAttribute('aria-hidden', String(closed));
      reopen.hidden = !closed;
      reopen.setAttribute('aria-expanded', String(!closed));
    };
    const updateScroll = () => {
      frame = 0;
      const y = Math.max(0, scrollY), delta = y - lastY;
      lastY = y;
      if (y < 100) { compact = false; pinned = false; travelled = 0; }
      else if (Math.abs(delta) > 1) {
        const next = Math.sign(delta);
        if (next !== direction) { direction = next; travelled = 0; }
        travelled += Math.abs(delta);
        if (travelled > 32) { compact = direction > 0; pinned = false; }
      }
      render();
    };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateScroll); }, { passive:true, signal });
    header.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; render(); } }, { signal });
    header.addEventListener('pointerleave', () => { hovered = false; render(); }, { signal });
    header.addEventListener('focusin', render, { signal });
    header.addEventListener('focusout', () => queueMicrotask(render), { signal });
    menu?.addEventListener('toggle', render, { signal });
    reopen.addEventListener('click', () => {
      pinned = true; render();
      if (matchMedia('(max-width:900px)').matches && menu) { menu.open = true; menu.querySelector('summary').focus({preventScroll:true}); }
      else content.querySelector('a').focus({preventScroll:true});
    }, { signal });
    document.addEventListener('pointerdown', e => {
      if (!header.contains(e.target)) { pinned = false; if(menu) menu.open = false; if(content.contains(document.activeElement)) document.activeElement.blur(); render(); }
    }, { signal });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || scrollY < 100 || !header.contains(document.activeElement)) return;
      pinned = hovered = false; compact = true;
      if(menu) menu.open = false;
      document.activeElement.blur(); render(); reopen.focus({preventScroll:true});
    }, { signal });
    render();
    cleanUp = () => { controller.abort(); cancelAnimationFrame(frame); content.inert=false; content.removeAttribute('aria-hidden'); };
  };
  init(); document.addEventListener('shopify:section:load', init);
})();
